export namespace Accordion {
	const Accordion = () => {
		const triggers = document.querySelectorAll('.js-acc-trigger');
		triggers.forEach(trigger => {
			trigger.addEventListener('click', e => {
				let parent = trigger.closest('.accordion-list__item');
				parent.classList.toggle('state-open');
				e.preventDefault();
			});
		});
	}

	const SetupStructuredContent = () => {
		let items = document.querySelectorAll('.accordion-list--faq .accordion-list__item');

		if(document.querySelector('.accordion-list--faq')) {
			let el = document.createElement('script');
			el.type = 'application/ld+json';
			let jsonString;
			let questions = [];


			items.forEach((item) => {
				let qstn = item.querySelector('.js-acc-trigger');
				let qstnCon:any = qstn.textContent;
				let content = item.querySelector('.accordion-list__content-inner');
				let contentCon:any = content.innerHTML;
				let theQuestion = {
					"@type": "Question",
					"name": qstnCon.replace(/(\r\t\n|\n|\r|\t)/gm, ""),
					"acceptedAnswer": {
						"@type": "Answer",
						"text": contentCon.replace(/(\r\t\n|\n|\r|\t)/gm, "")
					}
				}
				questions.push(theQuestion);
			});

			jsonString = {
				"@context": "https://schema.org",
				"@type": "FAQPage",
				"mainEntity": questions
			}

			el.text = JSON.stringify(jsonString);

			document.querySelector('head').appendChild(el);
		}
	}

	export const init = () => {
		Accordion();
		SetupStructuredContent();
	}
}

/**
 * DOMContentLoaded may fire before script has a chance to run, so it is wise to check before adding
 */
if (document.readyState === 'loading') {  // Loading hasn't finished yet
	document.addEventListener('DOMContentLoaded', Accordion.init);
} else {  // `DOMContentLoaded` has already fired
	Accordion.init();
}


